<template>
    <div class="right-container">
        <p class="right-h2">第三方插件</p>
        <p class="right-h3">jQuery</p>
        <p class="right-content">jQuery 是一个 JavaScript 库，极大地简化了 JavaScript 编程，并且很容易学习。这是 jQuery 的<a href="https://www.runoob.com/jquery/jquery-tutorial.html" target="_blank">中文教程</a>。</p>
        <p class="right-content"><a href="https://jquery.com/download/" target="_blank">官网下载</a></p>
        <p class="right-h3">jquery.countup.js/jquery.waypoints.js</p>
        <p class="right-content">jquery.countup.js 依赖于 jQuery 和 jquery.waypoints.js 的一个轻量级，通过简单的设置就可以达到数字滚动效果的插件。效果如下：</p>
        <div class="right-code">
            <pre>
                <code class="language-js line-numbers" v-html="code.plugins.plugins1"></code>
            </pre>
        </div>
        <img src="../../assets/img/1.gif">
        <p class="right-content">但是在项目中我们有时候并不需要它马上执行滚动效果，比如说在元素刚进入可视区域时再执行滚动效果，这时就需要 jquery.waypoints.js。</p>
        <p class="right-content">jquery.waypoints.js 是一款用于捕获各种滚动事件的插件。在项目中我们只需要引用它就可以让 jquery.countup.js 实现在元素刚进入可视区域时就执行滚动的效果了。</p>
        <div class="right-code">
            <pre>
                <code class="language-markup line-numbers" v-html="code.plugins.plugins2"></code>
            </pre>
        </div>
        <p class="right-content"><a href="/file/jquery.countup.min.zip" download>下载</a></p>
        <p class="right-h3">wow.js/Animate.css</p>
        <p class="right-content">Animate.css 是一个现成的跨浏览器动画库，可用于web项目。非常适合强调、主页、滑块和注意力引导提示。这是它的 <a href="https://animate.style/" target="_blank">官网</a></p>
        <p class="right-content">Animate.css 与 jquery.countup.js 一样都是只需要在元素刚进入可视区域时再执行效果，而这就需要用到 wow.js，它可以帮助我们实现想要的效果。代码如下：</p>
        <div class="right-code">
            <pre>
                <code class="language-markup line-numbers" v-html="code.plugins.plugins3"></code>
            </pre>
        </div>
        <p class="right-content">animated 和 fadeInUp 代表的是动画效果的类名，wow 代表的是 wow.js 监听元素的类名（wow.js默认监听元素的类名就是 wow）</p>
        <p class="right-content"><a href="/file/Animate.css.zip" download>下载</a></p>
        <p class="right-h3">swiper</p>
        <p class="right-content">制作跟轮播图功能相关的内容时，推荐使用swiper.js，这是一个非常好用的插件，而且很多大厂也在用它，比如说腾讯，小米，网易，百度等等。</p>
        <p class="right-content">它的使用也非常简单，可以在它的 <a href="https://www.swiper.com.cn/" target="_blank">官网</a> 查看文档。</p>
        <p class="right-content">在项目中建议使用swiper4，因为可以兼容更多的浏览器，如果项目有特别的样式需求，可以适当的升级swiper版本。</p>
        <p class="right-content">示例如下：</p>
        <div class="right-code">
            <pre>
                <code class="language-js line-numbers" v-html="code.plugins.plugins4"></code>
            </pre>
        </div>
    </div>
</template>

<script>
import code from '../../utils/code'
import Prism from 'prismjs'
import 'prismjs/themes/prism.css'
export default {
    name: 'plugins',
    data () {
        return {
            code: code
        }
    },
    mounted () {
        Prism.highlightAll()
    }
}
</script>

<style lang="scss" scoped>

</style>